module.exports = ".foto{\r\n\r\n    width: 80%; height: 80%;\r\n    margin: 2%;\r\n}\r\n"